import useSWR from "swr";
import { mutateRequest, swrKey } from "@/lib/swr";
import type { InboxCount, InboxItem, InboxQuery } from "@/types/domain";

export const INBOX_KEY = "/me/inbox";
export const INBOX_COUNT_KEY = "/me/inbox/count";

// The inbox is a live queue: other people's actions (a new rollout task, a
// engagement scheduled onto me) and my own actions on entity pages both change it,
// so unlike the browse lists it revalidates on tab focus and polls every
// minute while mounted (owner 2026-09-08). The badge follows the same rhythm.
const LIVE = { revalidateOnFocus: true, refreshInterval: 60_000 };

/** What's waiting on me (server-sorted by group, then due). No query = every
 * kind; each tab passes its own kind / status so only that slice is queried.
 * keepPreviousData: switching tabs keeps the old rows until the new ones land. */
export const useInbox = (query: InboxQuery = {}) =>
  useSWR<InboxItem[]>(
    swrKey(INBOX_KEY, query),
    { ...LIVE, keepPreviousData: true },
  );

/** Nav badge / section title counts. */
export const useInboxCount = () => useSWR<InboxCount>([INBOX_COUNT_KEY], LIVE);

/** Revalidate both inbox keys after any inline action (confirm / reject). */
export const refreshInbox = () => {
  mutateRequest(INBOX_KEY);
  mutateRequest(INBOX_COUNT_KEY);
};
